//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Filters from "@/components/RightDrawer/Filters.vue";

export default {
  name: "filters",
  components: {
    Filters,
  },
  mounted: function () {},
  data: () => ({
    category: true,
    segment: true,
    umbrella: true,
    brand: true,
    nature: true,
    internalCode: true,
    productDesc: true,
    retailer: true,
    insignia: true,
    chain: true,
    store: true,
    district: true,
    county: true,
    burrough: true,
    locality: true,
    nielsen: true,
    salesDirector: true,
    kam: true,
    nam: true,
    supervisor: true,
    seller: true,
    promoter: true,
    repositor: true,
    tags: true,
    retailerList: [
      {
        id: 1,
        name: "Sonae",
        // insignia: ['Continente', 'Worten']
      },
      {
        id: 2,
        name: "Jerónimo Martins",
        // insignia: ['Pingo Doce', 'Lidosol']
      },
      {
        id: 3,
        name: "Auchan",
        // insignia: ['Auchan', 'Box', 'MyAuchan']
      },
    ],
    insigniaList: {
      1: [
        {
          id: 1,
          name: "Continente",
        },
        {
          id: 2,
          name: "Worten",
        },
      ],
      2: [
        {
          id: 3,
          name: "Pingo Doce",
        },
        {
          id: 4,
          name: "Lidosol",
        },
      ],
      3: [
        {
          id: 5,
          name: "Auchan",
        },
        {
          id: 6,
          name: "Box",
        },
        {
          id: 7,
          name: "MyAuchan",
        },
      ],
    },
    chainList: [],
  }),
  methods: {
    updateData() {
      this.$emit("value", this.value);
    },
  },
};
